import React, { useEffect } from 'react';
import { Icon } from '../../../../../../components';
import { ContainerInput, Label, ShowCount } from './styles';

interface IinputPhone {
  value: string;
  name: string;
  placeholder: string;
  showCount?: boolean;
  nameLabel?: string;
  maxLength: number;
  setFieldError: ({ name, value }: any) => void;
  setFieldValue: ({ name, value }: any) => void;
  validateOnStart?: boolean;
  validateForm: number;
}

const InputPhone = (props: IinputPhone) => {
  const {
    value,
    name,
    placeholder,
    showCount,
    nameLabel,
    maxLength,
    setFieldError,
    setFieldValue,
    validateOnStart,
    validateForm
  } = props;
  const [errorText, setErrorText] = React.useState('');

  const validate = (value2: string) => {
    if (value2.length > maxLength) {
      setErrorText('Excediste el número de caracteres');
      return true;
    }
    if ((value2?.length > 0 && value2?.length < 6) || value2.length > 11) {
      setErrorText('Ingresa un número de teléfono válido');
      return true;
    }
    setErrorText('');
    return false;
  };

  const setValue = ({ name2, value2 }: any) => {
    setFieldError({ name: name2, value: validate(value2) });
    setFieldValue({ name: name2, value: value2 });
  };

  useEffect(() => {
    if ((validateOnStart || validateForm > 0) && !value) {
      setErrorText('Dato pendiente');
    }
  }, [validateOnStart, validateForm, value]);

  return (
    <ContainerInput
      data-testid="bse-form-inputPhone"
      style={{ margin: '0 0 16px 0' }}
    >
      {nameLabel && <Label color="#161d1f"> {nameLabel} </Label>}
      <input
        data-testid="cmp-input-phone-bse"
        autoComplete="off"
        value={value || ''}
        type="text"
        maxLength={maxLength}
        name={name}
        className={`${value ? 'inputFilled' : ''} ${
          errorText ? 'inputError' : ''
        }`}
        onChange={(e: any) => {
          setValue({
            name2: name,
            value2: e.target.value
              .replace(/[^0-9.]/g, '')
              .replace(/(\..*)\./g, '$1')
              .replace(/\./g, '')
          });
        }}
        placeholder={placeholder}
      />

      {showCount && (
        <ShowCount error={errorText}>
          {errorText && (
            <div className="errorText">
              <Icon name="alert-triangle" size={12} />
              {errorText}
            </div>
          )}
          {errorText === 'Dato pendiente' ? (
            ''
          ) : (
            <div>
              {value?.length ?? 0} / {maxLength}
            </div>
          )}
        </ShowCount>
      )}
    </ContainerInput>
  );
};

InputPhone.defaultProps = {
  showCount: true
};

export default InputPhone;
